import React, { Component } from "react";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import Cookies from "universal-cookie";
import { Button, Modal, Table, message, Form, Radio } from "antd";
import { dealerApiService } from "../../services/otodis/DealerApiService";
import { dealerService } from "../../services/otodisApi/DealerService";
import { EditOutlined } from "@ant-design/icons";
import { StopClosingStates } from "./types/StopClosingTypes";
import withAuth from "../../hoc/withAuth";

export interface HomeProps {}

class StopClosing extends Component<HomeProps & any, StopClosingStates> {
  private readonly initState!: StopClosingStates;
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private token = new Cookies().get("_t");
  private listIamDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());
  private tableColumn: any = [
    {
      title: "Kode Dealer",
      dataIndex: "dealer_code",
      width: 80,
    },
    {
      title: "Nama Dealer",
      dataIndex: "dealer_name",
      width: 150,
    },
    {
      title: "Stop Closing",
      dataIndex: "set_stop_closing",
      width: 80,
      render: (value: boolean, row: any) => {
        return <span className={`font-90`}>{value?.toString()?.toUpperCase()}</span>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
      render: (value: string, row: []) => {
        return (
          <React.Fragment>
            <Button size={"small"} type={"primary"} onClick={(event) => this.showEditModal(row)}>
              {" "}
              <EditOutlined /> Edit
            </Button>
          </React.Fragment>
        );
      },
    },
  ];

  constructor(props: (HomeProps & any) | any) {
    super(props);

    this.initState = {
      processing: false,
      processingFetchTableData: true,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      dataDealer: [],
      pageSize: 100,
      showModalEdit: false,
      rowDetailDealer: [],
      radioStopClosing: false,
      editProcess: false,
    };
    this.state = { ...this.initState };
  }

  closeModalEdit = (data: any) => {
    this.setState({
      showModalEdit: false,
    });
  };

  showEditModal = async (data: any) => {
    console.log(data);
    await this.promisedSetState({
      rowDetailDealer: data,
      radioStopClosing: data?.set_stop_closing,
      showModalEdit: true,
    });
  };

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });

    await this.fetchDealerData();
  };

  fetchDealerData = async () => {
    await this.promisedSetState({
      processingFetchTableData: true,
    });

    await dealerApiService
      .getDealer({
        // dealerCode: this.state.dealerCode
      })
      .then(async (value) => {
        const showDealer = [];
        for (const element of value.data.data) {
          const picked = this.listIamDealer.find((o: { DealerCode: string }) => o.DealerCode === element.dealer_code);
          if (picked) {
            showDealer.push(element);
          }
        }

        await this.promisedSetState({
          dataDealer: showDealer,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataDealer: [],
          processingFetchTableData: false,
        });
        message.error("Data Tidak Ditemukan");
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    console.log(pagination);
    console.log(filters);
    console.log(sorter);
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onFieldChange = async <T extends keyof Pick<any, "radioStopClosing">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "radioStopClosing":
        currentState.radioStopClosing = value;
        break;
    }
    await this.promisedSetState({
      ...currentState,
    });
  };

  triggerCancelOffer = async () => {
    await this.promisedSetState({
      editProcess: true,
    });

    try {
      await dealerApiService.setToken(this.token);
      await dealerService
        .updateStopClosing({
          company: "amarta",
          dealer_code: this.state.rowDetailDealer?.dealer_code,
          set_stop_closing: this.state.radioStopClosing,
          updated_by: this.user,
          admin_id: this.user,
          admin_name: this.user,
        })
        .then(async (successData) => {
          Modal.success({
            title: "Proses Sukses",
            content: "Data Berhasil Di Edit ",
          });
          this.defaultState();
          await this.fetchDealerData();
        });
    } catch (e) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
      await this.promisedSetState({
        editProcess: false,
      });
    }
  };

  defaultState = async () => {
    await this.promisedSetState({
      showModalEdit: false,
      rowDetailDealer: [],
      radioStopClosing: false,
      editProcess: false,
    });
  };

  async componentDidMount() {
    await this.fetchDealerData();
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Setting`}
          breadcrumbMenu={`Stop Closing Dealer`}
          defaultSelectedKeys={["m-setting-stop-closing"]}
          defaultOpenKeys={["sm-setting"]}
        >
          <div style={{ padding: 20 }}></div>
          <div />
          <Table
            rowKey={"dealer_code"}
            size={"small"}
            scroll={{ x: "calc(500px + 50%)" }}
            loading={this.state.processingFetchTableData}
            columns={this.tableColumn}
            dataSource={this.state.dataDealer}
            pagination={{ pageSize: this.state.pageSize }}
            onChange={this.onChangeTable}
          />

          <Modal
            visible={this.state.showModalEdit}
            title="Edit Dealer"
            onOk={this.closeModalEdit}
            onCancel={this.closeModalEdit}
            cancelText={"Tutup"}
            okText={false}
            footer={[
              <Button type={"primary"} loading={this.state.editProcess} key="1" onClick={this.triggerCancelOffer}>
                Simpan Perubahan
              </Button>,
              <Button loading={this.state.editProcess} key="2" onClick={this.closeModalEdit}>
                Close
              </Button>,
            ]}
          >
            <Form layout="vertical">
              <Form.Item label="Stop Closing">
                <Radio.Group value={this.state.radioStopClosing} onChange={(event) => this.onFieldChange("radioStopClosing", event.target.value)}>
                  <Radio value={true}>TRUE</Radio>
                  <Radio value={false}>FALSE</Radio>
                </Radio.Group>
              </Form.Item>
            </Form>
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(StopClosing), 40);
